import React from "react";

const About = () => {
  return (
    <div className="page-container">
      <h1>关于我们</h1>
      <p>这是一个使用 React 和 React Router 构建的示例应用。</p>
    </div>
  );
};

export default About;
